<template>
    <mdb-container v-if="news" fluid class="bg-white py-3">
        <h1 class="mb-5" v-html="news.title"></h1>
        <VueShowdown :markdown=news.anons />
        <VueShowdown :markdown=news.body />
    </mdb-container>
</template>

<script>

    import axios from 'axios';
    import store from '../../store';
    import {
        mdbContainer,
    } from "mdbvue";

    export default {
        name: "news",
        components: {
            mdbContainer,
        },
        data() {
            return {
                news: null
            }
        },
        watch: {
            $route() {
                axios.get(process.env.VUE_APP_CONTENT_2_URL + '/items/news/' + this.$route.params.id + '?fields=*.*&access_token=' + process.env.VUE_APP_CONTENT_2_REST_TOKEN, {headers:{Authorization: ''}})
                    .then(response => {
                        if(response.data.data.length === 0){
                            this.$router.push('/')
                        }else {
                            this.news = response.data.data[0];
                            store.commit('setBreadcrumbs',['Новости', this.news.news_category.title, this.news.title])
                        }
                    });
            }
        },
        mounted() {
            //TODO: filter by type = intranet
            axios.get(process.env.VUE_APP_CONTENT_2_URL + '/items/news/' + this.$route.params.id + '?fields=*.*&access_token=' + process.env.VUE_APP_CONTENT_2_REST_TOKEN, {headers:{Authorization: ''}})
                .then(response => {
                    if(!response.data.data){
                      this.$router.push('/')
                    }else {
                      this.news = response.data.data;
                      store.commit('setBreadcrumbs',['Новости', this.news.news_category.title, this.news.title])
                    }
                });
        }
    }
</script>

<style scoped>

</style>
